<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      // help的二级路由跳转时不添加动画效果
      if (this.$route.fullPath.split('/')[1] === 'help') {
        return this.$route.fullPath.split('/')[1]
      }
      return this.$route.path
    }
  }
}
</script>

<style scoped>

</style>
